// Primary filter - what type of data
export const LOAD_SHAPE_TYPE_OPTIONS = [
  { value: '', label: 'All Types' },
  { value: 'LSS_PERIOD', label: 'LSS Period' },
  { value: 'LSS_TOTAL', label: 'LSS Totals' },
];

// Geographic/Network filters
export const GSP_GROUP_OPTIONS = [
  { value: '', label: 'All GSP Groups' },
  { value: '_A', label: '_A' },
  { value: '_B', label: '_B' },
  { value: '_C', label: '_C' },
  { value: '_D', label: '_D' },
  { value: '_E', label: '_E' },
  { value: '_F', label: '_F' },
  { value: '_G', label: '_G' },
  { value: '_H', label: '_H' },
  { value: '_J', label: '_J' },
  { value: '_K', label: '_K' },
  { value: '_L', label: '_L' },
  { value: '_M', label: '_M' },
  { value: '_N', label: '_N' },
  { value: '_P', label: '_P' },
];

// Technical/Infrastructure filters (ordered by voltage level)
export const CONNECTION_TYPE_OPTIONS = [
  { value: '', label: 'All Connection Types' },
  { value: 'E', label: 'Extra High Voltage with Current Transformer' },
  { value: 'H', label: 'High Voltage with Current Transformer' },
  { value: 'L', label: 'Low Voltage with Current Transformer' },
  { value: 'U', label: 'Unmetered' },
  { value: 'W', label: 'Whole Current' },
];

export const MARKET_SEGMENT_OPTIONS = [
  { value: '', label: 'All Market Segments' },
  { value: 'A', label: 'Advanced' },
  { value: 'S', label: 'Smart' },
  { value: 'U', label: 'Unmetered' },
];

// Boolean-like filters
export const DOMESTIC_INDICATOR_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'F', label: 'No' },
  { value: 'T', label: 'Yes' },
];

// Product/Service filters
export const PRODUCT_OPTIONS = [
  { value: '', label: 'All Products' },
  { value: 'AE', label: 'AE' },
  { value: 'AI', label: 'AI' },
  { value: 'RE', label: 'RE' },
  { value: 'RI', label: 'RI' },
];
